import type { BatchResponse, WebObjectSourceType } from '@carboncopyco/types';
import { Debug } from '@carboncopyco/utils';
import { handleBatchRequest } from '../utils/handleBatchRequest';
import { mainApi } from './mainApi';

Debug.extend('demostack-data:api:webObjectApi');

export interface GetWebObjectArgs {
  organizationId: string;
  sourceType: WebObjectSourceType;
  sourceId: string;
  revisionId: string;
}

const webObjectApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    getWebObject: builder.query<BatchResponse<any>, GetWebObjectArgs>({
      query: ({ organizationId, sourceType, sourceId, revisionId, ...args }) =>
        handleBatchRequest({
          ...args,
          url: `/api/${organizationId}/${sourceType}/${sourceId}/${revisionId}/web-object/metadata`,
        }),
    }),
  }),
});

export const { useGetWebObjectQuery, useLazyGetWebObjectQuery } = webObjectApi;
